import { createStore, applyMiddleware, AnyAction } from 'redux';
import thunkMiddleware, { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './reducers';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

const loggerMiddleware = createLogger();

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;

export const store = createStore(
    rootReducer,
    // the explicit type arg makes store.dispatch thunk-aware: applyMiddleware
    // can't infer it (Ext is a phantom type param on Middleware)
    applyMiddleware<AppDispatch>(thunkMiddleware, loggerMiddleware),
);
export type AppThunk<Return = void> = ThunkAction<
    Return,
    RootState,
    unknown,
    AnyAction
>;
type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
